import { Option } from '../interfaces/Option';
import client from '../apollo-client';
import { gql } from '@apollo/client';

/** Setări oferte din tabelul `option` (servicii RO/EN + feature flags). Prețurile locale: `LocaleTariffService`. */
export interface OfferSettings {
  additionalServicesRo: string;
  additionalServicesEn: string;
  /** Feature flag: tabel all-in pe oferte Import (implicit false). */
  allInEnabled: boolean;
}

export class OptionService {
  async getOption(slug: string): Promise<Option> {
    const response = await client.query({
        query: gql`
          query {
            option(slug: "${slug}") {
              id
              title
              slug
              value
              type
            }
          }
        `,
        fetchPolicy: 'no-cache',
      });
      return response.data.option;
  }

  async getOfferSettings(): Promise<OfferSettings> {
    const response = await client.query({
      query: gql`
        query OfferSettings {
          offerSettings {
            additionalServicesRo
            additionalServicesEn
            allInEnabled
          }
        }
      `,
      fetchPolicy: 'network-only',
    });
    return response.data.offerSettings;
  }

  async updateOfferSettings(input: Partial<OfferSettings>): Promise<OfferSettings> {
    const response = await client.mutate({
      mutation: gql`
        mutation UpdateOfferSettings($input: UpdateOfferSettingsDto!) {
          updateOfferSettings(input: $input) {
            additionalServicesRo
            additionalServicesEn
            allInEnabled
          }
        }
      `,
      variables: { input },
    });
    return response.data.updateOfferSettings;
  }

  async updateOption(option: Partial<Option> & { id: number; slug: string }): Promise<Option> {
    const response = await client.mutate({
      mutation: gql`
        mutation UpdateOption($input: UpdateOptionDto!) {
          updateOption(input: $input) {
            id
            title
            slug
            value
            type
          }
        }
      `,
      variables: { input: option },
    });
    return response.data.updateOption;
  }

  async createOption(option: { slug: string; title?: string; value?: string; type?: string }): Promise<Option> {
    const response = await client.mutate({
      mutation: gql`
        mutation CreateOption($input: CreateOptionDto!) {
          createOption(input: $input) {
            id
            title
            slug
            value
            type
          }
        }
      `,
      variables: { input: option },
    });
    return response.data.createOption;
  }

  static async getPorts(): Promise<{ name: string; code: string; }[]> {
    try {
      const url = `${process.env.VITE_BACKEND_URI}/ports`;
      const response = await fetch(url, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching ports:', error);
      return [];
    }
  }

  static async getPortCodes(): Promise<string[]> {
    try {
      const url = `${process.env.VITE_BACKEND_URI}/ports/codes`;
      const response = await fetch(url, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
      return await response.json();
    } catch (error) {
      return [];
    }
  }
}
